module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/73557b737d416858232754c5c6b20b90.png";